<template>
  <form @submit.prevent="consultar">
    <div class="layout">
      <div class="layout__header">
        <div class="layout__title">
          <h3>{{ $t('message.consultaContenedores') }}</h3>
        </div>
      </div>
      <div class="card">
        <div class="card__content">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-inline">
                <div class="form-field select2">
                  <div class="select2-field select2-field--stretch">
                    <v-select
                      :tooltip="selectedPatio !== null?selectedPatio.nombre:null"
                      @input="inputPatio"
                      :options="patios"
                      label="name"
                      v-model="selectedPatio"
                      id="patio"
                      placeholder="Seleccione..."
                    ></v-select>
                    <label for="linea">Patio</label>
                  </div>
                </div>
                <label v-show="consultarEstimados" for="garita">
                  <input
                    @change="consultar"
                    value="G"
                    v-model="form.tipo_estado"
                    type="radio"
                    name="tipo_estado"
                    id="garita"
                  />
                  <span>{{ $t('message.gate_in') }}</span>
                </label>
                <label v-show="consultarEstimados" for="estimados">
                  <input
                    @change="consultar"
                    value="I"
                    v-model="form.tipo_estado"
                    type="radio"
                    name="tipo_estado"
                    id="estimados"
                  />
                  <span>{{ $t('message.estimados') }}</span>
                </label>
                <label v-show="consultarReparaciones" for="reparados">
                  <input
                    @change="consultar"
                    value="R"
                    v-model="form.tipo_estado"
                    type="radio"
                    name="tipo_estado"
                    id="reparados"
                  />
                  <span>{{ $t('message.reparados') }}</span>
                </label>
                <label v-show="consultarSalidas" for="despachados">
                  <input
                    @change="consultar"
                    value="S"
                    v-model="form.tipo_estado"
                    type="radio"
                    name="tipo_estado"
                    id="despachados"
                  />
                  <span>{{ $t('message.despachados') }}</span>
                </label>
                <label
                  v-show="!form.por_numero_contenedor"
                  for="tipoFecha"
                >{{ $t('message.tipoFecha') }}</label>
                <label v-show="!form.por_numero_contenedor" for="hoy" id="tipoFecha">
                  <input
                    @change="borrarFechas"
                    v-model="form.tipo_fecha"
                    value="H"
                    type="radio"
                    id="hoy"
                  />
                  <span>{{ $t('message.hoy') }}</span>
                </label>
                <label v-show="!form.por_numero_contenedor" for="ayer">
                  <input
                    @change="borrarFechas"
                    v-model="form.tipo_fecha"
                    value="A"
                    type="radio"
                    id="ayer"
                  />
                  <span>{{ $t('message.ayer') }}</span>
                </label>
                <label v-show="!form.por_numero_contenedor" for="personalizadas">
                  <input
                    @change="changePersonalizadas"
                    v-model="form.tipo_fecha"
                    value="P"
                    type="radio"
                    id="personalizadas"
                  />
                  <span>{{ $t('message.customDate') }}</span>
                </label>
                <label for="numeroContenedor">
                  <input
                    v-model="form.por_numero_contenedor"
                    type="checkbox"
                    name="numeroContenedor"
                    id="numeroContenedor"
                  />
                  <span>{{ $t('message.filterContainer') }}</span>
                </label>
                <div v-show="form.por_numero_contenedor" class="form-field">
                  <div class="form-group">
                    <input-field
                      placeholder="#####"
                      v-model="form.numero_contenedor"
                      id="numero_contenedor"
                    >
                      {{ $t('message.numeroContenedor') }}
                      <span
                        v-if="errores.numero_contenedor"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.numero_contenedor[0] }}</strong>
                      </span>
                    </input-field>
                    <button @click="consultar" class="btn-info" type="submit">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="!form.por_numero_contenedor" class="row">
            <div class="col-xs-12">
              <div class="form-inline">
                <div v-show="form.tipo_fecha === 'P'" class="form-field">
                  <div class="datepicker-field datepicker-field--stretch">
                    <date-picker
                      type="date"
                      format="dd-MM-yyyy"
                      id="desde"
                      v-model="form.desde"
                      lang="es"
                    ></date-picker>
                    <label>{{ $t('message.desde') }}</label>
                    <span v-if="errores.desde" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.desde[0] }}</strong>
                    </span>
                  </div>
                </div>
                <div v-show="form.tipo_fecha === 'P'" class="form-field">
                  <div class="datepicker-field datepicker-field--stretch">
                    <date-picker
                      type="date"
                      format="dd-MM-yyyy"
                      id="hasta"
                      v-model="form.hasta"
                      lang="es"
                    ></date-picker>
                    <label>{{ $t('message.hasta') }}</label>
                    <span v-if="errores.hasta" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.hasta[0] }}</strong>
                    </span>
                  </div>
                </div>
                <div class="form-field">
                  <div class="form-group">
                    <input-field
                      :placeholder="$t('message.buscar')"
                      id="consultar"
                      v-model="form.search"
                    >
                      <span v-if="errores.search" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores.search[0] }}</strong>
                      </span>
                    </input-field>
                    <button class="btn-info" type="submit">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>{{ $t('message.numeroContenedor') }}</th>
                      <th>{{ $t('message.fecha') }}</th>
                      <th>{{ $t('message.cliente') }}</th>
                      <th>{{ $t('message.patio') }}</th>
                      <th>U. Garita</th>
                      <th>U. Inspección</th>
                      <th>F. Insp. Caja</th>
                      <th>F. Insp. Máquina</th>
                      <th>F. Est. Caja</th>
                      <th>F. Est. Máquina</th>
                      <th>{{ $t('message.eirCaja') }}</th>
                      <th>{{ $t('message.eirMaquina') }}</th>
                      <th
                        v-show="form.tipo_estado !== 'D' && form.tipo_estado !== 'G' && form.tipo_estado !== 'S'"
                      >{{ $t('message.caja') }}</th>
                      <th
                        v-show="form.tipo_estado !== 'D' && form.tipo_estado !== 'G' && form.tipo_estado !== 'S'"
                      >{{ $t('message.maquina') }}</th>
                      <th
                        v-show="form.tipo_estado === 'D' && form.tipo_estado !== 'G' && form.tipo_estado !== 'S'"
                      >{{ $t('message.digitado') }}</th>
                      <th v-show="form.tipo_estado === 'S'">{{ $t('message.despachado') }}</th>
                      <th v-show="form.tipo_estado === 'G'">Gate IN</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      is="item-inspeccion"
                      v-for="(inspeccion, index) in inspecciones"
                      :key="index"
                      :inspeccion="{
                                            fecha : inspeccion.gate_in_date,
                                            numero_contenedor : inspeccion.number,
                                            eir_caja_in : inspeccion.eir_in,
                                            eir_maquina_in : inspeccion.eir_maquina_in,
                                            inspeccion_finalizada_c : (form.tipo_estado === 'G' && (inspeccion.garita_finalizada === 'S')) || (form.tipo_estado === 'I' && inspeccion.inspection_b === 'S') || (form.tipo_estado === 'E' && inspeccion.estimado_caja === 'S') || (form.tipo_estado === 'R' && inspeccion.repaired === 'S') || (form.tipo_estado === 'D' && inspeccion.digitado ==='S') || (form.tipo_estado === 'S' && inspeccion.kim_salida === 'S'),
                                            inspeccion_finalizada_m : (form.tipo_estado === 'G' && (inspeccion.garita_finalizada === 'S')) || (form.tipo_estado === 'I' && inspeccion.inspection_m === 'S') || (form.tipo_estado === 'E' && inspeccion.estimado_maquina === 'S') || (form.tipo_estado === 'R' && inspeccion.repaired_m === 'S') || (form.tipo_estado === 'D' && inspeccion.digitado ==='S') || (form.tipo_estado === 'S' && inspeccion.kim_salida === 'S'),
                                            cliente : inspeccion.customer.name,
                                            patio : inspeccion.yard !== null?inspeccion.yard.name:'',
                                            usuarioFinalizacion : inspeccion.cod_usuario_insp,
                                            usuario_garita : inspeccion.usuario_garita_fin,
                                            date_i_m : inspeccion.date_i_m,
                                            date_i_b : inspeccion.date_i_b,
                                            fecha_e_maquina : inspeccion.date_e_m,
                                            fecha_e_caja : inspeccion.date_e_b
                                        }"
                      :tipoEstado="form.tipo_estado"
                      :estado="form.tipo_estado"
                      :bloqueadoMaquina="false"
                      :bloqueadoCaja="false"
                    ></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    consultarDigitaciones: {
      type: Boolean,
      required: true,
      default: false
    },
    consultarGateIn: {
      type: Boolean,
      required: true,
      default: false
    },
    consultarEstimados: {
      type: Boolean,
      required: true,
      default: false
    },
    consultarReparaciones: {
      type: Boolean,
      required: true,
      default: false
    },
    consultarSalidas: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: "Consulta de contenedores"
    },
    contenedorText: {
      type: String,
      required: false,
      default: "Contenedor"
    },
    fechaText: {
      type: String,
      required: false,
      default: "Fecha"
    },
    eirCajaText: {
      type: String,
      required: false,
      default: "EIR Caja"
    },
    eirMaquinaText: {
      type: String,
      required: false,
      default: "EIR Máquina"
    },
    inspectorText: {
      type: String,
      required: false,
      default: "Inspector"
    },
    patioText: {
      type: String,
      required: false,
      default: "Patio"
    },
    clienteText: {
      type: String,
      required: false,
      default: "Cliente"
    },
    finalizadaText: {
      type: String,
      required: false,
      default: "Finalizada"
    },
    usuarioFinalizacionText: {
      type: String,
      required: false,
      default: "Usuario de finalización"
    },
    tipoFechaText: {
      type: String,
      required: false,
      default: "Tipo de fecha"
    },
    desdeText: {
      type: String,
      required: false,
      default: "Desde"
    },
    hastaText: {
      type: String,
      required: false,
      default: "Hasta"
    },
    hoyText: {
      type: String,
      required: false,
      default: "Hoy"
    },
    ayerText: {
      type: String,
      required: false,
      default: "Ayer"
    },
    consultarText: {
      type: String,
      required: false,
      default: "Consultar"
    },
    errorText: {
      type: String,
      required: false,
      default: "Error"
    },
    errorMessageText: {
      type: String,
      required: false,
      default: "Hubo un error, intente nuevamente."
    },
    avisoText: {
      type: String,
      required: false,
      default: "Aviso"
    },
    personalizadasText: {
      type: String,
      required: false,
      default: "Fechas personalizadas"
    },
    sinRegistrosText: {
      type: String,
      required: false,
      default: "Sin registros"
    },
    patios: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      patioDefault: patioDefault,
      inspecciones: [],
      form: {
        tipo_fecha: "H",
        search: "",
        desde: "",
        hasta: "",
        por_numero_contenedor: false,
        numero_contenedor: "",
        tipo_estado: "E",
        patio_id: ""
      },
      errores: {},
      url: url,
      selectedPatio: null
    };
  },
  methods: {
    inputPatio: function() {
      if (this.selectedPatio !== null)
        this.form.patio_id = this.selectedPatio.code;
      else this.form.patio_id = "";
      this.consultar();
    },
    inputNumeroContenedor: function() {
      if (this.selectedContenedor !== null)
        this.form.numero_contenedor = this.selectedContenedor.number;
      else this.form.numero_contenedor = "";
    },
    consultar: function() {
      let that = this;
      this.inspecciones = [];
      this.errores = {};
      axios
        .get(this.url + "/inspecciones", {
          params: this.form
        })
        .then(function(response) {
          that.inspecciones = response.data;
        })
        .catch(function(error) {
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              let status = response.status;
              if (status === 422) that.errores = response.data.errors;
              else
                swal(
                  that.$t("message.errorText"),
                  that.$t("message.error"),
                  "error"
                );
            }
          }
        });
    },
    borrarFechas: function() {
      this.form.desde = "";
      this.form.hasta = "";
      this.consultar();
    },
    changePersonalizadas: function() {
      let date = new Date();
      date.setDate(date.getDate() - 5);
      this.form.desde = moment(date).format("YYYY-MM-DD");
      this.form.hasta = moment(new Date()).format("YYYY-MM-DD");
      //this.consultar();
    }
  },
  mounted: function() {
    if (this.consultarGateIn) this.form.tipo_estado = "G";
    else if (this.consultarEstimados) this.form.tipo_estado = "I";
    else if (this.consultarReparaciones) this.form.tipo_estado = "R";
    else if (this.consultarSalidas) this.form.tipo_estado = "S";
    if (this.patioDefault != null && this.patioDefault != '') {
      for (let i = 0; i < this.patios.length; i++) {
        if (this.patios[i].code == this.patioDefault) {
          this.selectedPatio = this.patios[i];
          break;
        }
      }
    }
    else {
      if (this.patios.length > 0) {
        this.selectedPatio = this.patios[0];
        this.inputPatio();
      }
    }
    this.consultar();
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/inspeccion/ConsultaInspecciones.vue